var render = function render(){
  var _vm$selectedSessionFo, _vm$selectedSessionFo3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "select-session d-flex flex-column"
  }, [_c('h1', {
    staticClass: "page-title sessions-toolbar-layer"
  }, [_vm._v("Sessions")]), _c('div', {
    staticClass: "d-flex flex-wrap align-center toolbar-container sessions-toolbar-layer"
  }, [_c('v-btn', {
    staticClass: "toolbar-button toolbar-action-button",
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.$router.push({
          name: 'RecordingMode'
        });
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" New session ")], 1), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "toolbar-button toolbar-action-button"
        }, 'v-btn', attrs, false), on), [_c('span', {
          staticClass: "dashboards-text d-none d-sm-inline mr-2"
        }, [_vm._v("Dashboards")]), _c('span', {
          staticClass: "dashboards-text-mobile d-sm-none"
        }, [_vm._v("Dashboards")]), _c('v-icon', [_vm._v("mdi-menu")])], 1)];
      }
    }])
  }, [_c('v-list', [_c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": _vm.openKinematicsDashboardFromMenu
    }
  }, [_vm._v(" Kinematics ")]), _vm._l(_vm.analysis_dashboards, function (dashboard) {
    return _c('v-list-item', {
      key: dashboard.id,
      on: {
        "click": function ($event) {
          return _vm.openAnalysisDashboardFromMenu(dashboard);
        }
      }
    }, [_vm._v(" " + _vm._s(dashboard.title))]);
  }), _vm.analysis_dashboards.length === 0 ? _c('v-list-item', {
    staticClass: "dashboards-empty-hint",
    attrs: {
      "disabled": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-subtitle', {
    staticClass: "text-wrap"
  }, [_vm._v(" No analysis dashboards yet. Open a trial’s menu from a session page → Analysis, run one, and it will appear here when finished. ")])], 1)], 1) : _vm._e()], 2)], 1), _c('v-btn', {
    staticClass: "toolbar-button toolbar-action-button",
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.$router.push({
          name: 'Subjects'
        });
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-account-group-outline")]), _vm._v(" Subjects ")], 1), _c('v-btn', {
    staticClass: "toolbar-button toolbar-action-button",
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.$router.push({
          name: 'RecycleBin'
        });
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-delete-outline")]), _vm._v(" Recycle Bin ")], 1), _c('div', {
    staticClass: "show-removed-checkbox toolbar-checkbox"
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Show removed sessions",
      "hide-details": "",
      "dense": ""
    },
    model: {
      value: _vm.show_trashed,
      callback: function ($$v) {
        _vm.show_trashed = $$v;
      },
      expression: "show_trashed"
    }
  })], 1), _c('div', {
    staticClass: "d-flex align-center flex-grow-1 flex-md-grow-0 ml-0 ml-md-auto mt-2 mt-md-0 search-section"
  }, [_c('div', {
    staticClass: "flex-grow-1 mr-2"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Session ID/Name",
      "prepend-inner-icon": "mdi-magnify",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  })], 1), _vm.searchText ? _c('div', [_c('v-btn', {
    staticClass: "submit-btn toolbar-action-button",
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.onClearSearch();
      }
    }
  }, [_vm._v(" Clear ")])], 1) : _vm._e()])], 1), _c('div', {
    staticClass: "sessions-table-wrapper"
  }, [_c('v-data-table', {
    staticClass: "sessions-table flex-grow-1",
    attrs: {
      "headers": _vm.displayHeaders,
      "items": _vm.valid_sessions,
      "options": _vm.options,
      "item-class": _vm.itemClasses,
      "loading": _vm.loading,
      "server-items-length": _vm.session_total,
      "mobile-breakpoint": 0,
      "dense": _vm.$vuetify.breakpoint.smAndDown,
      "footer-props": {
        showFirstLastPage: false,
        disableItemsPerPage: true,
        itemsPerPageOptions: [40]
      },
      "fixed-header": "",
      "single-select": ""
    },
    on: {
      "update:options": function ($event) {
        _vm.options = $event;
      },
      "item-selected": _vm.onSelect,
      "click:row": _vm.onRowClick
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function () {
        return [_c('div', {
          staticClass: "table-empty-state"
        }, [_c('v-icon', {
          staticClass: "mb-3",
          attrs: {
            "size": "48",
            "color": "grey"
          }
        }, [_vm._v(_vm._s(_vm.searchText.trim() ? 'mdi-magnify' : 'mdi-folder-open-outline'))]), _c('p', {
          staticClass: "mb-0"
        }, [_vm._v(_vm._s(_vm.searchText.trim() ? 'No matching sessions' : 'No sessions yet'))]), _c('p', {
          staticClass: "text-caption mb-0 mt-1"
        }, [_vm._v(_vm._s(_vm.searchText.trim() ? 'Try a different search term or clear the search' : 'Create a new session to get started'))])], 1)];
      },
      proxy: true
    }, {
      key: "item.created_at",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('span', [_vm._v(_vm._s(_vm._f("date")(item.created_at)))])];
      }
    }, {
      key: "item.id",
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('div', {
          staticClass: "session-id-cell",
          attrs: {
            "title": item.id
          }
        }, [_c('span', {
          staticClass: "session-id-preview"
        }, [_vm._v(_vm._s(_vm.getSessionIdPreview(item.id)))]), _c('v-btn', {
          staticClass: "copy-session-id-btn",
          attrs: {
            "icon": "",
            "small": "",
            "dark": "",
            "title": "Copy session ID"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.copySessionId(item.id);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-content-copy")])], 1)], 1)];
      }
    }, {
      key: "item.controls",
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('div', {
          staticClass: "session-controls-cell"
        }, [_c('div', {
          staticClass: "action-buttons-desktop d-none d-md-flex align-center"
        }, [_c('v-btn', {
          staticClass: "action-btn",
          attrs: {
            "icon": "",
            "small": "",
            "dark": "",
            "title": "Load session"
          },
          on: {
            "click": function ($event) {
              return _vm.$router.push({
                name: 'Session',
                params: {
                  id: item.id
                }
              });
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-play")])], 1), _c('v-btn', {
          staticClass: "action-btn",
          attrs: {
            "icon": "",
            "small": "",
            "dark": "",
            "title": "Dashboard kinematics"
          },
          on: {
            "click": function ($event) {
              return _vm.$router.push({
                name: 'Dashboard',
                params: {
                  id: item.id
                }
              });
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-chart-line")])], 1), _c('v-btn', {
          staticClass: "action-btn",
          attrs: {
            "icon": "",
            "small": "",
            "dark": "",
            "title": "Rename session"
          },
          on: {
            "click": function ($event) {
              return _vm.openRenameDialog(item);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-pencil")])], 1), !item.trashed ? _c('v-btn', {
          staticClass: "action-btn",
          attrs: {
            "icon": "",
            "small": "",
            "dark": "",
            "title": "Trash session"
          },
          on: {
            "click": function ($event) {
              _vm.selectedSessionForDelete = item;
              _vm.remove_dialog = true;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-delete")])], 1) : _vm._e(), item.trashed ? _c('v-btn', {
          staticClass: "action-btn",
          attrs: {
            "icon": "",
            "small": "",
            "dark": "",
            "title": "Restore session"
          },
          on: {
            "click": function ($event) {
              _vm.selectedSessionForDelete = item;
              _vm.restore_dialog = true;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-restore")])], 1) : _vm._e()], 1), _c('div', {
          staticClass: "d-md-none"
        }, [_vm.$vuetify.breakpoint.smAndDown ? [_c('v-btn', {
          staticClass: "menu-button",
          attrs: {
            "icon": "",
            "dark": "",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openSessionMenuSheet(item);
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-menu")])], 1)] : [_c('v-menu', {
          attrs: {
            "offset-y": "",
            "right": "",
            "close-on-content-click": "",
            "content-class": "session-context-menu"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref5) {
              var on = _ref5.on,
                attrs = _ref5.attrs;
              return [_c('v-btn', _vm._g(_vm._b({
                staticClass: "menu-button",
                attrs: {
                  "icon": "",
                  "dark": "",
                  "small": ""
                }
              }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-menu")])], 1)];
            }
          }], null, true),
          model: {
            value: item.isMenuOpen,
            callback: function ($$v) {
              _vm.$set(item, "isMenuOpen", $$v);
            },
            expression: "item.isMenuOpen"
          }
        }, [_c('v-list', [_c('v-list-item', {
          attrs: {
            "link": ""
          },
          on: {
            "click": function ($event) {
              return _vm.closeMenuAndLoad(item);
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Load")])], 1), _c('v-list-item', {
          attrs: {
            "link": ""
          },
          on: {
            "click": function ($event) {
              return _vm.closeMenuAndDashboard(item);
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Dashboard kinematics")])], 1), _c('v-list-item', {
          attrs: {
            "link": ""
          },
          on: {
            "click": function ($event) {
              return _vm.closeMenuAndRename(item);
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Rename")])], 1), _c('v-list-item', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !item.trashed,
            expression: "!item.trashed"
          }],
          attrs: {
            "link": ""
          },
          on: {
            "click": function ($event) {
              return _vm.closeMenuAndTrash(item);
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Trash")])], 1), _c('v-list-item', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: item.trashed,
            expression: "item.trashed"
          }],
          attrs: {
            "link": ""
          },
          on: {
            "click": function ($event) {
              return _vm.closeMenuAndRestore(item);
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Restore")])], 1)], 1)], 1)]], 2)])];
      }
    }, {
      key: "item.sessionName",
      fn: function (_ref6) {
        var item = _ref6.item;
        return [_c('div', {
          staticClass: "session-name-text",
          attrs: {
            "title": item.sessionName || 'Untitled'
          }
        }, [_vm._v(_vm._s(item.sessionName || 'Untitled'))])];
      }
    }, {
      key: "item.isMono",
      fn: function (_ref7) {
        var item = _ref7.item;
        return [_c('span', [_vm._v(_vm._s(item.isMono ? 'Yes' : 'No'))])];
      }
    }])
  })], 1), _c('v-bottom-sheet', {
    attrs: {
      "content-class": "bottom-sheet-rounded"
    },
    on: {
      "input": function (val) {
        return !val && (_vm.selectedSessionForMenu = null);
      }
    },
    model: {
      value: _vm.showSessionMenuSheet,
      callback: function ($$v) {
        _vm.showSessionMenuSheet = $$v;
      },
      expression: "showSessionMenuSheet"
    }
  }, [_c('v-sheet', {
    staticClass: "text-center session-menu-sheet"
  }, [_vm.selectedSessionForMenu ? _c('v-list', [_c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function ($event) {
        return _vm.closeSheetAndLoad(_vm.selectedSessionForMenu);
      }
    }
  }, [_c('v-list-item-content', [_c('div', {
    staticClass: "d-flex flex-row align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("mdi-play")]), _c('span', [_vm._v("Load")])], 1)])], 1), _c('v-divider'), _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function ($event) {
        return _vm.closeSheetAndDashboard(_vm.selectedSessionForMenu);
      }
    }
  }, [_c('v-list-item-content', [_c('div', {
    staticClass: "d-flex flex-row align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("mdi-chart-line")]), _c('span', [_vm._v("Dashboard kinematics")])], 1)])], 1), _c('v-divider'), _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function ($event) {
        return _vm.closeSheetAndRename(_vm.selectedSessionForMenu);
      }
    }
  }, [_c('v-list-item-content', [_c('div', {
    staticClass: "d-flex flex-row align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("mdi-pencil")]), _c('span', [_vm._v("Rename")])], 1)])], 1), !_vm.selectedSessionForMenu.trashed ? _c('v-divider') : _vm._e(), !_vm.selectedSessionForMenu.trashed ? _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function ($event) {
        return _vm.closeSheetAndTrash(_vm.selectedSessionForMenu);
      }
    }
  }, [_c('v-list-item-content', [_c('div', {
    staticClass: "d-flex flex-row align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("mdi-delete-outline")]), _c('span', [_vm._v("Trash")])], 1)])], 1) : _vm._e(), _vm.selectedSessionForMenu.trashed ? _c('v-divider') : _vm._e(), _vm.selectedSessionForMenu.trashed ? _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function ($event) {
        return _vm.closeSheetAndRestore(_vm.selectedSessionForMenu);
      }
    }
  }, [_c('v-list-item-content', [_c('div', {
    staticClass: "d-flex flex-row align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("mdi-restore")]), _c('span', [_vm._v("Restore")])], 1)])], 1) : _vm._e()], 1) : _vm._e()], 1)], 1), _c('v-dialog', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutsideDialogSessionHideMenu,
      expression: "clickOutsideDialogSessionHideMenu"
    }],
    attrs: {
      "content-class": "compact-rename-dialog app-dialog",
      "max-width": "420",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown
    },
    model: {
      value: _vm.rename_dialog,
      callback: function ($$v) {
        _vm.rename_dialog = $$v;
      },
      expression: "rename_dialog"
    }
  }, [_vm.selectedSessionForRename ? _c('v-card', [_c('v-btn', {
    staticClass: "dialog-close-btn",
    attrs: {
      "icon": "",
      "small": "",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function ($event) {
        _vm.rename_dialog = false;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-close")])], 1), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', {
    staticClass: "m-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "orange"
    }
  }, [_vm._v("mdi-rename-box")])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [_c('p', {
    staticClass: "mb-1"
  }, [_vm._v(" Insert a new name for session " + _vm._s(_vm.selectedSessionForRename.sessionName) + ": ")]), _c('ValidationObserver', {
    ref: "observer",
    staticClass: "d-flex flex-column",
    attrs: {
      "tag": "div"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref8) {
        var invalid = _ref8.invalid;
        return [_c('ValidationProvider', {
          attrs: {
            "rules": "required|alpha_dash_custom",
            "name": "Session name"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref9) {
              var errors = _ref9.errors;
              return [_c('v-text-field', {
                staticClass: "flex-grow-0",
                attrs: {
                  "label": "Session new name",
                  "error": errors.length > 0,
                  "error-messages": errors[0]
                },
                model: {
                  value: _vm.sessionNewName,
                  callback: function ($$v) {
                    _vm.sessionNewName = $$v;
                  },
                  expression: "sessionNewName"
                }
              })];
            }
          }], null, true)
        }), _c('v-spacer'), _c('v-btn', {
          staticClass: "text-right",
          attrs: {
            "disabled": invalid
          },
          on: {
            "click": _vm.confirmRenameSession
          }
        }, [_vm._v(" Rename Session ")])];
      }
    }], null, false, 4085671987)
  })], 1)], 1)], 1)], 1) : _vm._e()], 1), _c('v-dialog', {
    attrs: {
      "content-class": "confirm-dialog",
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "retain-focus": false
    },
    model: {
      value: _vm.remove_dialog,
      callback: function ($$v) {
        _vm.remove_dialog = $$v;
      },
      expression: "remove_dialog"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', {
    staticClass: "m-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "red"
    }
  }, [_vm._v("mdi-close-circle")])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [_c('p', [_vm._v(" Do you want to trash session "), _c('code', [_vm._v(_vm._s((_vm$selectedSessionFo = _vm.selectedSessionForDelete) === null || _vm$selectedSessionFo === void 0 ? void 0 : _vm$selectedSessionFo.id))]), _vm._v("? You will be able to restore it for 30 days. After that, this session will be permanently removed. ")])])], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.remove_dialog = false;
        _vm.selectedSessionForDelete = null;
      }
    }
  }, [_vm._v(" No ")]), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        var _vm$selectedSessionFo2;
        _vm.remove_dialog = false;
        _vm.trashSession((_vm$selectedSessionFo2 = _vm.selectedSessionForDelete) === null || _vm$selectedSessionFo2 === void 0 ? void 0 : _vm$selectedSessionFo2.id);
        _vm.selectedSessionForDelete = null;
      }
    }
  }, [_vm._v(" Yes ")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "content-class": "confirm-dialog",
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "retain-focus": false
    },
    model: {
      value: _vm.restore_dialog,
      callback: function ($$v) {
        _vm.restore_dialog = $$v;
      },
      expression: "restore_dialog"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', {
    staticClass: "m-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "green"
    }
  }, [_vm._v("mdi-undo-variant")])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [_c('p', [_vm._v(" Do you want to restore session "), _c('code', [_vm._v(_vm._s((_vm$selectedSessionFo3 = _vm.selectedSessionForDelete) === null || _vm$selectedSessionFo3 === void 0 ? void 0 : _vm$selectedSessionFo3.id))]), _vm._v("? ")])])], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.restore_dialog = false;
        _vm.selectedSessionForDelete = null;
      }
    }
  }, [_vm._v(" No ")]), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        var _vm$selectedSessionFo4;
        _vm.restore_dialog = false;
        _vm.restoreSession((_vm$selectedSessionFo4 = _vm.selectedSessionForDelete) === null || _vm$selectedSessionFo4 === void 0 ? void 0 : _vm$selectedSessionFo4.id);
        _vm.selectedSessionForDelete = null;
      }
    }
  }, [_vm._v(" Yes ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }